<template>
    <!-- <div v-if="status === 1" class="detail-card"> -->
    <div class="detail-card">
        <div class="card-header">
            <div class="title">
                <span v-if="flg === -1"> 收款對象 </span>
                <span v-else> 付款對象 </span>
            </div>
        </div>
        <div class="card-body">
            <spec-view>
                <spec-item label="付款銀行"> {{ bankName || "--" }} </spec-item>
                <spec-item label="付款帳戶"> {{ bnkAcc || "--" }} </spec-item>
                <spec-item label="付款戶名"> {{ bnkTcp || "--" }}</spec-item>
            </spec-view>
        </div>
    </div>
</template>

<script>
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';

export default {
    props: {
        bnkAcc: {
            type: String,
            default: '',
        },
        bnkBoo: {
            type: String,
            default: '',
        },
        bnkDoo: {
            type: String,
            default: '',
        },
        bnkTcp: {
            type: String,
            default: '',
        },
        bankName: {
            type: String,
            default: '',
        },
        flg: {
            type: Number,
            default: 0,
        },
    },
    components: { SpecView, SpecItem },
    data() {
        return {
            accountingDetailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    computed: {
        statusTxt() {
            switch (this.status) {
            case 1:
                return '完成';
            case 2:
                return '不作帳';
            default:
                return '待辦';
            }
        },
    },
    methods: {
        onOpenAccountingDetail() {
            this.accountingDetailDialog.sno = this.sno;
            this.accountingDetailDialog.visible = true;
        },
        onAccountingDetailDialogClose(refresh) {
            this.accountingDetailDialog.visible = false;
            this.accountingDetailDialog.sno = null;
            if (refresh) this.$emit('refresh');
        },
    },
};
</script>

<style lang="scss" scoped>
.clickable {
    cursor: pointer;
}
</style>
